
const SEARCH_HISTORY_KEY = 'TNA_SEARCH_HISTORY'
const LIMIT = 10

export interface SearchHistoryItem {
  expires: Number
  url: string
  text: string[]
  payload: any
}

/**
 * 记录搜索历史
 * 数据源：
 *  1、一定时间内储存的数据（如60天内），有最多展示数量的限制（如近10条）
 *  2、搜索历史是记录在设备Device维度的
    搜索历史展示的数据：
      1、用户Enter时带的query或者用户点击suggest的suggest title
      范围：用户在T&A Vertical Homepage & Activity list page搜索框 主动搜索&访问的数据 都可以进搜索历史（不仅限于目的地，还可以包括类目词，目的地x类目词，热搜词/联想词，AID suggestion等）
      2、搜索历史数据需要去重（按文本去重），只保留最新的一条记录（如搜索历史是Tokyo，Osaka-Day trip。今天用户又搜了Osaka-Day trip的话，最后搜索历史会展示为Osaka-Day trip，Tokyo)
      记住每次搜索的跳转页面和召回逻辑，即用户再次点击某个搜索历史后 会去到和上次一样的landing page 且召回方式保持一致（如上一次通过目的地x类目词去到列表页的话，再次点击后也是同样的效果；上一次通过AID suggestion去到活动页后，再次点击后也是同样的效果）
    3、suggest活动不记历史记录(demo后新增)
 * **/

export function recordSearchHistory(
  text: string | string[],
  url: string,
  payload: any = {}
) {
  const searchHistoryData = getSearchHistoryData()

  if (searchHistoryData) {
    const updatedData = updateSearchHistoryData(searchHistoryData, text, url, payload)

    localStorage.setItem(SEARCH_HISTORY_KEY, JSON.stringify(updatedData))
  } else {
    const item: SearchHistoryItem = composeSearchHistoryItem(text, url, payload)

    localStorage.setItem(SEARCH_HISTORY_KEY, JSON.stringify([item]))
  }
}

export function getSearchHistoryData() {
  const searchHistoryData = localStorage.getItem(SEARCH_HISTORY_KEY)

  if (searchHistoryData) {
    return JSON.parse(searchHistoryData)
  }

  return null
}

export function removeSearchHistoryData() {
  localStorage.removeItem(SEARCH_HISTORY_KEY)
}

function updateSearchHistoryData(
  data: SearchHistoryItem[],
  text: string | string[],
  url: string,
  payload: any
) {
  // 清洗过期数据
  const clearedData = clearInvalidSearchHistory(data)
  const index = clearedData.findIndex((item: SearchHistoryItem) => {
    const paramKey = Array.isArray(text) ? text.join('') : text
    const itemKey = item.text.join('')

    return paramKey === itemKey
  })

  const len = clearedData.length
  const item: SearchHistoryItem = composeSearchHistoryItem(text, url, payload)

  if (index >= 0) {
    clearedData.splice(index, 1)
  } else if (len >= LIMIT) {
    clearedData.pop()
  }
  clearedData.unshift(item)

  return clearedData
}

// 清洗过期时间数据
function clearInvalidSearchHistory(data: SearchHistoryItem[]) {
  const currentTime = new Date().getTime()

  return (data || []).filter((item: SearchHistoryItem) => currentTime < item.expires && item.text.every(Boolean)
  )
}

function composeSearchHistoryItem(text: string | string[], url: string, payload: any = {}) {
  return {
    // 保存60天过期
    expires: new Date().getTime() + 60 * 24 * 60 * 60 * 1000,
    text: Array.isArray(text) ? text : [text],
    url,
    payload
  }
}
